<template>
    <div class="product-container">
        <div class="content-box ">
            <div class="title-box">
                <span class="title">下载</span>

                <span class="desc"> /Download</span>
            </div>
            <div class="title-box2">
                <span>用科技承载灵感，助艺术触达未来。</span>
            </div>
            <div class="line-box">
                <div class="line"></div>
            </div>
            <div class="title-box3">
                <span>独家华艺链·守护您的艺术版权</span> <br>
                <span>元空间画廊·承载艺术作品在线上焕发无限商机</span>
            </div>
            <div class="btn-box">
                <a href="https://sj.qq.com/appdetail/com.jcy.huayiyuanjie?&from_wxz=1" target="_blank">

                    <div class="an-box">
                        <android theme="outline" size="26" fill="#fff" />
                        <span class="desc">安卓下载</span>

                    </div>
                </a>
                <a href="https://apps.apple.com/cn/app/华艺元界/6743516162">

                    <div class="an-box">
                        <apple theme="outline" size="26" fill="#fff" />
                        <span class="desc">苹果下载</span>
                    </div>
                </a>

            </div>

        </div>
    </div>
</template>

<script>
import { Android, Apple } from '@icon-park/vue'
export default {
    props: ['addAnimate'],
    components: {
        Android,
        Apple
    },
    data () {
        return {
            title1: '用科技承载灵感，助艺术触达未来。',
            title2: '释放无限创意，让每一件艺术作品都能遇见知音',
            desc1: '  华艺链 · 守护您的艺术版权', // 控制滚动
            desc2: '  元空间画廊 · 承载艺术作品在线上焕发无限商机'
        }
    }
}
</script>

<style lang="less" scoped>
.product-container {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-image: url(~@/assets/img/product.png);
    background-size: auto 50%;
    background-position: -100px 500px;

    /* 背景图片从水平和垂直方向的中间开始 */
    background-repeat: no-repeat;

    .content-box {
        position: relative;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        padding-top: 80px;
        width: auto;
        height: 100vh;
        box-sizing: border-box;

        .title-box {
            width: 100%;
            height: 80px;
            box-sizing: border-box;
            text-align: start;
            text-indent: 2rem;

            .title {
                font-size: 30px;
                font-weight: bolder;
                color: #FE793A;

            }

            .desc {
                font-size: 18px;
                color: #ACABAD;
            }

        }

        .title-box2 {
            width: 100%;
            height: 75px;
            letter-spacing: 1px;
            /* 值可以是px/em/rem等 */
            box-sizing: border-box;
            text-align: start;
            text-indent: 2rem;

            span {
                text-align: start;
                font-size: 20px;
                font-weight: bold;
                color: #040300;
            }
        }

        .line-box {
            width: 100%;
            height: 50px;
            padding-left: 30px;

            .line {
                width: 80px;
                height: 2px;
                background-color: #FE793A;

            }
        }

        .title-box3 {
            width: 100%;
            height: 50px;
            padding-left: 30px;
            box-sizing: border-box;

            text-align: start !important;

            span {
                font-size: 16px;
                line-height: 50px;

            }

        }

        .btn-box {
            position: absolute;
            top: 400px;
            width: 100%;
            height: 100px;
            display: flex;
            padding: 0 20px;
            justify-content: space-between;
            box-sizing: border-box;

            .an-box {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 150px;
                height: 50px;
                background-color: #FF793A;
                border-radius: 50px;
                cursor: pointer;

                .desc {
                    padding-top: 12px;
                    height: 28px;
                    color: #fff;
                }

                &:hover {
                    background-color: #de6f3c;
                }

            }
        }

    }

}
</style>